<template>
  <div class="text-xs-center">
    <h1 class="text-pagename">Rank Management</h1>
    <v-card v-if="levelBenefit.length != 0" style="padding:5px; ">
      <div v-for="(item, index) in levelBenefit" :key="index">
        <v-card class="mx-3 pa-2 mb-2" style="position:relative;">
          <div style="width:70%;display:inline-block;">
            <v-layout row wrap>
              <v-flex xs12 sm2>
                <img
                  :src="item.level_benefit_image"
                  v-if="item.level_benefit_image"
                  width="100px"
                  height="100px"
                />
              </v-flex>
              <v-flex xs12 sm5>
                <v-card flat>
                  <v-layout row wrap justify-center align-center>
                    <v-flex xs9 class="py-2 pt-2">
                      <div class="flex pa-2" style="border: 1px solid grey; border-radius: 20px; ">
                        <p
                          style="color:#757575; text-align:start"
                        >Title(TH) : {{ item.level_benefit_name_th }}</p>
                        <p
                          style="color:#757575; text-align:start"
                        >Title(EN) : {{ item.level_benefit_name_en }}</p>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <v-flex xs12 sm5>
                <v-card flat style>
                  <v-layout row wrap justify-center align-center>
                    <v-flex xs9 class="py-2 pt-2">
                      <div class="flex pa-2" style="border: 1px solid grey; border-radius: 20px; ">
                        <p style="color:#757575; text-align:start">
                          Description(TH) :
                          {{ item.level_benefit_description_th }}
                        </p>
                        <p style="color:#757575; text-align:start">
                          Description(EN) :
                          {{ item.level_benefit_description_en }}
                        </p>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </div>

          <div style="width:30%;height:100%;display:inline-block;">
            <div style="position:absolute; top:30%; right:10%">
              <div class="button">
                <v-btn icon @click="mockupData(item)" :loading="isUpdating">
                  <v-icon medium>edit</v-icon>
                </v-btn>
                <v-btn icon slot="activator" :loading="isDeleting.includes(item.level_benefit_id)">
                  <v-icon medium @click="deleteLevelBenefit(item)">delete</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </v-card>
    <v-card v-else>
      <div class="mx-3 pa-2 mb-2" style="height:100px;">ไม่มีข้อมูล</div>
    </v-card>

    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Edit title and description</v-card-title>

        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field v-model="form.level_benefit_name_th" label="TITLE (TH)" required></v-text-field>

            <v-text-field v-model="form.level_benefit_name_en" label="TITLE (EN)" required></v-text-field>

            <v-text-field
              v-model="form.level_benefit_description_th"
              label="DESCRIPTION (EN)"
              required
            ></v-text-field>

            <v-text-field
              v-model="form.level_benefit_description_en"
              label="DESCRIPTION (EN)"
              required
            ></v-text-field>
            <v-layout row align-center>
              <span style="font-size:16px;">Level Benefit image:</span>
              <v-btn color="info" class="white--text" @click="$refs.LogoInput.click()">Upload</v-btn>
              <input
                style="display:none;"
                type="file"
                @change="onImageSelected"
                ref="LogoInput"
                accept="image/*"
              />
            </v-layout>
            <img
              :src="form.level_benefit_image"
              v-if="form.level_benefit_image"
              width="100px"
              height="100px"
            />
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" text @click="dialog = false">cancle</v-btn>
          <v-btn color="primary" text @click="editLevelBenefit()" :loading="isUpdating">save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    levelBenefit: Array,
  },
  data() {
    return {
      dialog: false,
      isUpdating: false,
      notEmpty: true,
      isDeleting: [],
      form: {
        level_benefit_id: null,
        level_benefit_name_th: "",
        level_benefit_name_en: "",
        level_benefit_description_th: "",
        level_benefit_description_en: "",
        level_benefit_image: "",
        level_benefit_level_id: null,
        level_benefit_status: 1,
        level_benefit_series: 999,
      },
    };
  },

  methods: {
    async deleteLevelBenefit(item) {
      let n = await this.$confirm("Do you want to delete this level benefit?");
      if (n == true) {
        this.isDeleting.push(item.level_benefit_id);
        await this.$store.dispatch(
          "tierBenefits/deleteLevelBenefit",
          item.level_benefit_id
        );
        let key = this.isDeleting.findIndex(
          (val) => val == this.levelBenefit.level_benefit_id
        );
        this.isDeleting.splice(key, 1);
      }
    },

    onImageSelected(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.form.level_benefit_image = reader.result;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    async editLevelBenefit() {
      if (this.$refs.form.validate()) {
        let formCopy = JSON.parse(JSON.stringify(this.form));
        let result = await this.$store.dispatch(
          "tierBenefits/updateLevelBenefit",
          formCopy
        );
        this.isUpdating = true;
        if (result == true) {
          this.resetForm();
          this.dialog = false;
        }
        this.isUpdating = false;
      }
    },
    resetForm() {
      this.form = {
        level_benefit_id: "",
        level_benefit_name_th: "",
        level_benefit_name_en: "",
        level_benefit_description_th: "",
        level_benefit_description_en: "",
        level_benefit_image: "",
        level_benefit_level_id: null,
        level_benefit_status: 1,
        level_benefit_series: 999,
      };
    },
    mockupData(item) {
      this.form.level_benefit_id = item.level_benefit_id;
      this.form.level_benefit_name_th = item.level_benefit_name_th;
      this.form.level_benefit_name_en = item.level_benefit_name_en;
      this.form.level_benefit_description_th =
        item.level_benefit_description_th;
      this.form.level_benefit_description_en =
        item.level_benefit_description_en;
      this.form.level_benefit_level_id = item.level_benefit_level_id;

      this.dialog = true;
    },
  },
};
</script>
<style scoped>
.button {
  display: flex;
  align-content: center;
}
</style>
